<template lang="pug">
  .secondarymenu
    nav
      router-link(:to="section.slug" v-for="(section, index) in sections" :key="index" v-if="!section.hidden")
        span {{section.title}}
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'home',
  computed: mapState([
    'sections'
  ]),
}
</script>
<style scoped lang="scss">
  .secondarymenu{
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    z-index: 2;
    height: 0;
  }
  nav{
    a{
      display: inline-block;
      font-size: 1.5rem;
      padding: 1rem 1rem;
      border: 1px solid rgba(white, 0.6);
      color: white;
    }
  }
</style>


